<template>
  <div id="global-nav">
    <el-menu
      text-color="#707173"
      active-text-color="#707173"
      mode="horizontal"
      :router="true">
      <el-menu-item index="/">{{Constants.PRODUCT_NAME}}</el-menu-item>
      <el-menu-item v-if="!isLogged" index="/login">ログイン</el-menu-item>
      <el-menu-item v-else index="" @click="logout">ログアウト</el-menu-item>
      <el-menu-item index="" @click="showGuide">利用マニュアル</el-menu-item>
      <el-menu-item index="/first">はじめての方へ</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'global-nav',
  computed: {
    ...mapGetters('User', ['isLogged'])
  },
  methods: {
    logout () {
      var self = this
      this.$store.dispatch('User/logout').then(function () {
        self.$router.push('/login')
      })
    },
    showGuide () {
      window.open(this.Constants.GUIDE_URL, "target='_blank'")
    }
  }
}
</script>

<style scoped>
.el-menu-item:not(:first-child){
  float:right;
}
.el-menu-item.is-active{
  border-bottom:none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/02-organisms/GlobalNav.vue